<template>
  <svg
    :class="customStyle"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 4.25L8.5 8.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.625 7.08333L8.5 8.5L6.375 7.08333"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.25001 2.125L12.75 2.125C13.1412 2.125 13.4583 2.44213 13.4583 2.83334L13.4583 14.1667C13.4583 14.5579 13.1412 14.875 12.75 14.875L7.39282 14.875C7.19551 14.875 7.00714 14.7927 6.87308 14.6479L3.73026 11.2537C3.60903 11.1227 3.54168 10.9509 3.54168 10.7724L3.54167 2.83334C3.54167 2.44213 3.85881 2.125 4.25001 2.125Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.54166 10.625L7.08332 10.625C7.47452 10.625 7.79166 10.9421 7.79166 11.3333L7.79166 14.875"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'FileDocumentDownloadIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
